var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('GenericListTable',{attrs:{"parentID":this.parentID,"title":"Physical Info","headers":[
        { text: 'ID', value: 'id' },
        { text: 'Smartdevice Id', value: 'smartdeviceid' },
        { text: 'Serial Number', value: 'serialnum' },
        { text: 'Physical Type', value: 'physicaltype' },
        { text: 'Device Name', value: 'devicename' }
      ],"url":"/manifest/physicalinfo","apiResponseField":"physicalinfolist","onClickRoute":"AssetSingle","onClickParams":_vm.getOnClickParams,"editable":true,"saveUrl":"manifest/physicalinfo/bulk?ids_to_update="}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }